/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';

import { assign } from 'lodash';

@Component({
  standalone: false,
  selector: 'gh-todo-settings-panel-control',
  templateUrl: 'settings-panel-control.component.html',
  styleUrls: ['settings-panel-control.component.scss'],
})
export class SettingsPanelControlComponent {
  @Input() quantity: number = 0;
  @Input() title: string = '';
  @Input() ghIcon: string = '';
  @Input() checked: boolean = false;

  @Output() settingChanged = new EventEmitter<any>();
  private value: boolean = false;

  settingChanges(value: boolean): void {
    this.settingChanged.emit(value);
    assign(this, { value });
  }

}
